import { API_BASE_URL } from '../config/api';
import { getPublicErrorMessage } from '../utils/errorUtils';

const ensureAuthToken = (token) => {
  if (!token) {
    throw new Error('Missing authentication token.');
  }
};

export async function getQaNotifications(token, { page } = {}) {
  ensureAuthToken(token);

  const params = new URLSearchParams();
  if (page) params.set('page', String(page));
  const query = params.toString() ? `?${params.toString()}` : '';

  const res = await fetch(`${API_BASE_URL}/api/qa/notifications${query}`, {
    headers: { Authorization: `Bearer ${token}` },
    cache: 'no-store',
  });

  if (!res.ok) {
    const message = await res.text();
    throw new Error(getPublicErrorMessage(message) || 'Failed to fetch notifications.');
  }

  return res.json();
}

export async function markQaNotificationRead(token, id) {
  ensureAuthToken(token);

  const res = await fetch(`${API_BASE_URL}/api/qa/notifications/${id}/read`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const message = await res.text();
    throw new Error(getPublicErrorMessage(message) || 'Failed to mark notification read.');
  }

  return res.json();
}

export async function markAllQaNotificationsRead(token) {
  ensureAuthToken(token);

  const res = await fetch(`${API_BASE_URL}/api/qa/notifications/read-all`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const message = await res.text();
    throw new Error(getPublicErrorMessage(message) || 'Failed to mark notifications read.');
  }

  return res.json();
}
